import { withCurrentParams } from 'actions/utils';
import { BROADCAST_RESET_SOURCES } from 'actions/Types';
import {
  isAssignedPresenterSource,
  UNASSIGNED,
  EMPTY_THUMBNAIL
} from 'utils/broadcastSourceHelper';
import { shouldHaveFeature } from '@studio/feature.flags';
import { VENDOR_CHIME } from '@studio/constants';

/**
 * We want to reset sources from a pending state to an un-assigned state
 * Typically happens when a meeting is inactive and chime is trying to establish a connection
 * with an inactive meeting
 */
export default () => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const { broadcastSources, broadcast, meeting } = getState();

      const cameraPresenters = broadcastSources.sources.filter(
        isAssignedPresenterSource
      );

      const cameraPresenterIds = cameraPresenters.map(
        presenter => presenter._id
      );

      const action = {
        type: BROADCAST_RESET_SOURCES,
        request: async apiClient => {
          const meetingVendor = shouldHaveFeature('studio.meetingVendor');
          const isVendorChime = [
            VENDOR_CHIME,
            null,
            false,
            '',
            'false'
          ].includes(meetingVendor);
          let status;

          if (isVendorChime) {
            const response = await apiClient.broadcast.getMeetingStatus(
              teamId,
              eventId,
              broadcastId
            );
            status = response.status;
          } else {
            const defaultMeetingId = `studio-${broadcast._id}`;
            const broadcastMeetingId = meeting.meetingId;

            status =
              broadcastMeetingId === defaultMeetingId ? 'active' : 'inactive';
          }

          let updatedSources = null;

          if (status === 'inactive' && cameraPresenterIds.length > 0) {
            // set sources as unassigned
            let changes = {
              value: UNASSIGNED,
              thumbnail: EMPTY_THUMBNAIL
            };

            const sourcesToBeUpdated = cameraPresenterIds.reduce(
              (acc, presenterId) => {
                const { sources } = acc;
                return {
                  sources: [...sources, { ...changes, _id: presenterId }]
                };
              },
              { sources: [] }
            );

            updatedSources = await apiClient.broadcast.updateSources(
              teamId,
              eventId,
              broadcastId,
              sourcesToBeUpdated
            );
          }

          return updatedSources;
        }
      };

      dispatch(action);
    }
  );
};
